
import { getTenantDir } from "@/plugins/env"
export default {
  name: "StoreInfo",
  props: {
    storeInfo: {
      type: Object,
      default: () => {}
    },
    services: {
      type: Array,
      default: () => []
    },
    dir: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      // dir: null
    }
  },
  computed: {
    openingHours() {
      return this.storeInfo.openingHours.replace(/\n/g, "<br />")
    },
    serviceImages() {
      return this.storeInfo.serviceIds
        ?.map(id => {
          const imgUrl = this.getServiceImgUrl(id)
          return imgUrl ? { id, imgUrl } : null
        })
        .filter(Boolean)
    }
  },
  mounted() {
    // this.dir = getTenantDir()
  },
  methods: {
    getServiceImgUrl(id) {
      return this.services.find(item => item.id == id)?.imgUrl
    }
  }
}
